import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhotos = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M28.9945 6.85074C28.9182 5.81588 28.0544 5 27 5H5L4.85074 5.00549C3.81588 5.08183 3 5.94564 3 7V25L3.00549 25.1493C3.08183 26.1841 3.94564 27 5 27H27L27.1493 26.9945C28.1841 26.9182 29 26.0544 29 25V7L28.9945 6.85074ZM5 21.414L11 15.4142L16.5858 21L16.7156 21.1189C17.0742 21.4193 17.5285 21.5858 18 21.5858C18.5304 21.5858 19.0391 21.3751 19.4142 21L22 18.4142L27 23.415V25H5V21.414ZM27 7H5V18.584L9.58577 14C9.96084 13.6249 10.4695 13.4142 11 13.4142C11.4715 13.4142 11.9258 13.5807 12.2844 13.8811L12.4142 14L18 19.5858L20.5858 17C20.9608 16.6249 21.4695 16.4142 22 16.4142C22.4715 16.4142 22.9258 16.5807 23.2844 16.8811L23.4142 17L27 20.585V7ZM21 12.5C21 11.6716 20.3284 11 19.5 11C18.6716 11 18 11.6716 18 12.5C18 13.3284 18.6716 14 19.5 14C20.3284 14 21 13.3284 21 12.5Z"
	})
});
export default SvgPhotos;
